import './styles/tokens.scss'
import './styles/reset.scss'
import './styles/globals.scss'

import {createElement} from 'react'
import {createRoot} from 'react-dom/client'
import {App} from './app.jsx'
import {registerServiceWorker} from './pwa/register-sw.js'

const MSW_TIMEOUT_MS = 5000

function withTimeout(promise, ms, tag) {
    return Promise.race([
        promise,
        new Promise((_, reject) => setTimeout(() => reject(new Error(`${tag} timed out after ${ms}ms`)), ms))
    ])
}

async function startMocks() {
    if (process.env.MOCK_API !== 'true')
        return
    try {
        const {worker} = await import('./mocks/browser.js')
        await withTimeout(
            worker.start({
                onUnhandledRequest: 'bypass',
                serviceWorker: {url: '/mockServiceWorker.js'}
            }),
            MSW_TIMEOUT_MS,
            'MSW worker.start'
        )
    } catch (err) {
        console.warn('[MSW] mocks unavailable; continuing without them.', err)
    }
}

function mountApp() {
    document.getElementById('pre-loader')?.remove()
    const container = document.getElementById('root')
    if (!container)
        throw new Error('Missing #root element')
    const root = createRoot(container)
    root.render(createElement(App))
    registerServiceWorker().catch(err => console.warn('[sw] register failed', err))
}

startMocks()
    .catch(err => console.warn('[MSW] bootstrap error', err))
    .finally(mountApp)
